import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AccountStatementList } from '../../../../components/admin-dashboard-component/Account Statement/account-statement-list/account-statement-list';

@Component({
  selector: 'app-account-statement-veiw-list',
  imports: [AccountStatementList],
  templateUrl: './account-statement-veiw-list.html',
  styleUrl: './account-statement-veiw-list.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountStatementVeiwList {}
